import clsx from 'clsx';
import React from 'react';

export const Rounded = ({ children, className }) => {
  return <div className={clsx('rounded-full', className)}>{children}</div>;
};
